<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-07-14 10:49:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-02 10:34:20
-->
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 10:17:48
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 15:27:41
-->
<template>
   <div>
    
        <a-drawer
          :title="'报送稿件/投稿'"
          :width="'900px'"
          :visible="visible"
          :maskClosable="false"
          :body-style="{ paddingBottom: '80px' }"
          @close="close"
        >
        <div style="padding:24px">
            <div class="title-box">
        <i class="el-icon-info icon-title"></i>
        <div>
          请完整填写以下内容，若因约稿而产生的投稿，请务必选择对应约稿信息
        </div>
      </div>
        <a-spin :spinning="detailShow">
            <div>
              <div class="form">
                <el-form
                  :model="ruleForm"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="80px"
                  class="demo-ruleForm"
                >
                 <div style="display:flex;width:100%">
                    <el-form-item style="flex:1" label="是否约稿">
                     <el-select @change="selectIsMy" :disabled="!isAdd" style="width:100%" v-model="ruleForm.type" placeholder="请选择">
                      <el-option
                        v-for="item in [
                          {
                            value: 1,
                            label: '是'
                          },
                           {
                            value: 2,
                            label: '否'
                          }
                        ]"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                   <el-form-item v-if="ruleForm.type == 1" style="flex:1;margin-left:30px" label="选择约稿" prop="reservationId">
                      <el-select @change="changeOne" :disabled="!isAdd || ruleForm.type == 2" style="width:100%" v-model="ruleForm.reservationId" placeholder="请选择">
                      <el-option
                        v-for="item in listData"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.type == 2" style="flex:1;margin-left:30px" label="选择约稿">
                      <el-select  :disabled="!isAdd || ruleForm.type == 2" style="width:100%" v-model="ruleForm.reservationId" placeholder="请选择">
                      <el-option
                        v-for="item in listData"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    </el-form-item>
                 </div>
                  <el-form-item label="稿件标题" prop="title">
                      <el-input
                        v-model="ruleForm.title"
                        maxlength="100"
                        placeholder="请输入稿件标题"
                      ></el-input>
                    </el-form-item>
                    <div style="display:flex;width:100%">
                    <el-form-item style="flex:1" label="报送人员" prop="submitName">
                    <el-input
                      v-model="ruleForm.submitName"
                      maxlength="50"
                      placeholder="请输入报送人员"
                    ></el-input>
                  </el-form-item>
                   <el-form-item style="flex:1;margin-left:30px" label="目标组织" prop="targetOrganId">
                         <a-tree-select
                              v-model="orgids"
                              size="small"
                              style="width: 100%"
                               :disabled="ruleForm.type == 1"
                              :tree-data="treeData"
                              
                                @select="onSelect"
                              
                              :dropdownMatchSelectWidth="true"
                              :treeCheckStrictly="true"
                              dropdownClassName="drop-box"
                              :dropdown-style="{ maxHeight:'200px',overflow: 'auto',lineHeight:'38px' }"
                            />
                    </el-form-item>
                 </div>
                  <el-form-item v-if="codeData.indexOf('360') != -1" class="file-box" label="附件上传" prop="file">
                      <el-input
                          placeholder="支持pdf、docx、xlsx、zip、xls、doc格式"
                          disabled
                          style="border-right: none"
                          v-model="fileData.name"
                        >
                          <el-upload
                            :before-upload="(file) => beforeUpload(file)"
                            slot="append"
                            :show-file-list="false"
                            :multiple="false"
                            action="#"
                          >
                            <span  v-if="!fileData.name">选择附件</span>
                            <i @click.stop="deletFile" v-if="fileData.name"   class="el-icon-delete"></i>
                          </el-upload>
                        
                        </el-input>
                    </el-form-item>
                  <uEditorWrap
                          v-model="ruleForm.content"
                          @ready="ueditorReady"
                          editor-id="editor"
                          :config="uEditorConfig"
                          :editorDependencies="[
                            'ueditor.config.js',
                            'ueditor.all.js',
                          ]"
                          style="height:300px;min-width:600px"
                        />
                </el-form>
              </div>
            </div>
         
        </a-spin>
        </div>
        <div class="bottom">
          <div class="form-bottom">
                <el-button @click="close"   size="small" >关闭</el-button>
                <el-button  v-if="codeData.indexOf('358') != -1 || codeData.indexOf('386') != -1" @click="submit" :loading="submitShow" style="background-color: rgba(223, 237, 255, 1);color: rgba(23, 109, 230, 1);border: 1px solid rgba(23, 109, 230, 1);" type="primary" plain   size="small" >保存</el-button>
                <el-button
                  v-if="item.state != 2 && (codeData.indexOf('359') != -1 || codeData.indexOf('387') != -1)"
                  type="primary"
                  size="small"
                  :loading="submitShowTwo"
                  @click="saveAndSubmitted"
                  style="margin-left: 14px"
                  >保存并报送</el-button
                >
              
              </div>
          </div>
      </a-drawer>    
   </div> 
</template>

<script>
import uEditorWrap from "vue-ueditor-wrap";
import {
  tree,
  sendMeSelectList,
  createDada,
  createAndSubmit,
  contribute
} from "./index";
import { uploadImg, uploadVideo } from "@/utils/common.js";
import _ from "lodash";
export default {
  data() {
    let self = this;
    return {
      uEditorConfig: {
        // 配置UEditorPlus的惊天资源
        UEDITOR_HOME_URL: process.env.VUE_APP_Admin || "/admin/static/uEditor/",
        UEDITOR_CORS_URL: process.env.VUE_APP_Admin || "/admin/static/uEditor/",
        // 服务器统一请求接口路径
        serverUrl:
          process.env.VUE_APP_BASE_URL + "/site-service/m/cover/uploadImage",
        // 启用拖放上传
        enableDragUpload: true,
        // 启用粘贴上传
        enablePasteUpload: true,
        // 启用图片拉伸缩放
        imageScaleEnabled: true,
      },
      toolbarConfig: {
        excludeKeys: ["todo", "emotion"],
      },
      editorConfig: {
        hoverbarKeys: {
          attachment: {
            menuKeys: ["downloadAttachment"], // “下载附件”菜单
          },
        },
        MENU_CONF: {
          uploadAttachment: {
            // 用户自定义上传
            customUpload(file, insertFn) {
              self.loadingBox = true;
              uploadImg(file, "fujian").then((res) => {
                self.loadingBox = false;
                var encodedData = window.btoa(
                  process.env.VUE_APP_Img_Ip + res.path
                ); // 编码
                let url = `${process.env.VUE_APP_Preview}?url=` + encodedData;
                insertFn(`${file.name}`, url);
              });
            },
          },
          fontFamily: {
            fontFamilyList: [
              "仿宋_GB2312",
              "黑体",
              "仿宋",
              "楷体",
              "标楷体",
              "华文仿宋",
              "华文楷体",
              "宋体",
              "微软雅黑",
              "Arial",
              "Tahoma",
              "Verdana",
              "Times New Roman",
              "Courier New",
            ],
          },
          uploadImage: {
            server: `${process.env.VUE_APP_BASE_URL}/site-service/m/cover/uploadImage`,
            fieldName: "file",
            meta: {
              type: "img",
            },
            headers: {
              token: sessionStorage.getItem("token"),
            },
            customInsert: this.customInsert,
            onProgress(progress) {
              // TS 语法
              self.loadingBox = true;
            },
            onSuccess(file, res) {
              // TS 语法
              self.loadingBox = false;
            },
            onFailed(file, res) {
              self.loadingBox = false;
            },
          },
          fontSize: {
            fontSizeList: [
              { name: "初号", value: "56px" },
              { name: "小初", value: "48px" },
              { name: "一号", value: "34px" },
              { name: "小一", value: "32px" },
              { name: "二号", value: "29px" },
              { name: "小二", value: "24px" },
              { name: "三号", value: "21px" },
              { name: "小三", value: "20px" },
              { name: "四号", value: "18px" },
              { name: "小四", value: "16px" },
              { name: "五号", value: "14px" },
              { name: "小五", value: "12px" },
            ],
          },
          lineHeight: {
            lineHeightList: ["1", "1.5", "2", "2.5", "3"],
          },
          // uploadVideo: {
          //   server:
          //     `${process.env.VUE_APP_BASE_URL}/site-service/m/cover/uploadImage`,
          //   fieldName: "file",
          //   meta: {
          //     type: "video",
          //   },
          //   maxFileSize:100* 1024 * 1024 * 1024,
          //   timeout: 60 * 60 * 1000,
          //   // 上传错误，或者触发 timeout 超时
          //   onError(file, err, res) {  // TS 语法
          //   // onError(file, err, res) {               // JS 语法
          //       console.log(`${file.name} 上传出错`, err, res)
          //   },
          //   // 单个文件上传成功之后
          //   onSuccess(file, res) {  // TS 语法
          //       console.log(`${file.name} 上传成功`, res)
          //       self.loadingBox = false;
          //   },
          //   onBeforeUpload(file) {   // TS 语法
          //         return file
          //     },
          //      onProgress(progress) {  // TS 语法
          //        self.loadingBox = true;
          //     },
          //   headers: {
          //     token: sessionStorage.getItem("token"),
          //   },
          //   customInsert: this.customInsert,
          // },
          uploadVideo: {
            maxFileSize: 100 * 1024 * 1024 * 1024,
            timeout: 60 * 60 * 1000,
            customUpload(file, insertFn) {
              // TS 语法
              self.loadingBox = true;
              uploadVideo(file, "video").then((res) => {
                if (res.video.path) {
                  self.loadingBox = false;
                  insertFn(
                    self.imgIp + res.video.path,
                    self.imgIp + res.image.path
                  );
                }
              });
            },
          },
        },
      },
      mode: "default", // or 'simple'
      title: "",
      rules:{},
      codeData:[],
      submitShow:false,
      submitShowTwo:false,
      editor:'',
      ruleForm:{
        content:'',
      },
      orgids:'',
      detailShow:false,
      visibleTwo:false,
      createTime: new Date(),
      jsonContent: [
        {
          type: "paragraph",
          lineHeight: "1.5",
          children: [{ text: "", fontFamily: "宋体", fontSize: "18px" }],
        },
      ],
      imageUrl:'',
      height:0,
      width:0,
      treeData:[],
      listData:[],
      fileData:{},
      checkedSiteIdTwo:[],
      fileName:'',
       rules: {
        type: [{ required: true, message: "请选择是否约稿", trigger: "blur" }],
        reservationId: [{ required: true, message: "请选择是否约稿", trigger: "change" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        submitName: [{ required: true, message: "请输入报送人", trigger: "blur" }],
        targetOrganId: [{ required: true, message: "请选择目标组织", trigger: "change" }],
      },
    };
  },
  components: {
    uEditorWrap,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type:{
      type:Number,
      default:1,
    },
    item:{
      type:Object,
      default:{},
    },
    isAdd:{
      type: Boolean,
      default: true,
    }
    
  },
  mounted() {},
  watch: {
    visible(val) {
      this.visibleTwo = val;
      if(this.visibleTwo){
        if(this.isAdd){
            this.ruleForm = {};
            this.fileData = {};
            this.orgids = undefined;
            this.ruleForm.reservationId = this.item.reservationId;
            if(this.type == 1 && this.item.submitManuscriptId){
                this.deils()
            }
        }else{
          this.deils()
        }
        this.getList();
        this.getSendMeSelectList();
      }
      this.ruleForm.type = this.type;
      this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    },
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    deils(){
        let id = '';
        if(this.type == 1){
            id = this.item.submitManuscriptId;
        }else if(this.type == 2){
            id = this.item.manuscriptId;
        }
         contribute({
          id,
         }).then((res)=>{
              if(res.code == 0){
                  this.ruleForm = res.data;
                  this.listData = [{
                    id:res.data.reservationId,
                    title:res.data.reservationName,
                  }]
                  this.orgids = res.data.targetOrganId;
                  this.fileData = JSON.parse(res.data.file);
              }
            })
    },
    close(){
       this.$emit("close");
    },
    //  handleNodeClickTwo(checkedKeys) {
    //   this.checkedSiteIdTwo = [].concat(
    //     checkedKeys[checkedKeys.length - 1]
    //   );
    //   this.orgids  = this.checkedSiteIdTwo;
    //    this.$nextTick(()=>{
    //      this.orgids  =  this.orgids.filter(function (s) {
    //         if(s && s.value){
    //           return  s;
    //         }
             
    //     });
    //    })
    // },
    onSelect(checkedKeys){
        this.orgids = checkedKeys;
    },
    ueditorReady(editor) {
      this.editor = editor;
      this.editor.addListener("fullscreenchanged", function (t, enabled) {
        if (!enabled) {
          editor.unsetFloating();
        }
      });
    },
    submit(){
          this.ruleForm.targetOrganId = this.orgids;
          this.ruleForm.file = JSON.stringify(this.fileData);
          this.$refs.ruleForm.validate(valid => {
            if(valid){
              this.submitShow = true;
                 createDada({
             ...this.ruleForm,
             organizationId:this.item.organizationId,
           }).then((res)=>{
                    if(res.code == 0){
                        this.onClose();
                    }
                    this.submitShow = false;
                })
            }
          })
    },
    saveAndSubmitted(){
        this.ruleForm.targetOrganId = this.orgids;
          this.ruleForm.file = JSON.stringify(this.fileData);
          this.$refs.ruleForm.validate(valid => {
            if(valid){
               this.submitShowTwo = true;
                 createAndSubmit({
             ...this.ruleForm,
             organizationId:this.item.organizationId,
           }).then((res)=>{
                    if(res.code == 0){
                        this.onClose();
                    }
                    this.submitShowTwo = false;
                })
            }
          })
    },
     deletFile(){
        this.fileData = {};
    },

     beforeUpload(file) {
       this.detailShow = true;
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (["pdf", "docx", "xlsx","zip","xls","doc"].indexOf(fileSuffix) == -1) {
        this.$message.error("请上传 pdf、docx、xlsx、zip、xls、doc格式!");
        this.detailShow = false;
        return;
      }
      uploadImg(file, "file_annex").then((res) => {
        this.fileData = res;
        this.detailShow = false;
      });
      return false;
    },
    selectIsMy(e){
       this.ruleForm.type = e;
       this.ruleForm.targetOrganId = '';
       this.orgids = '';
       this.ruleForm.reservationId = '';
       this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm))
    },
    changeOne(e){
        for (let index = 0; index < this.listData.length; index++) {
          const element = this.listData[index];
          if(element.id == e){
             this.orgids = element.organizationId;
          }
        }
    },
    getSendMeSelectList(){
        sendMeSelectList({}).then((res)=>{
            if(res.code == 0){
                this.listData = res.data;
                for (let index = 0; index < this.listData.length; index++) {
                  const element = this.listData[index];
                  if(element.id == this.ruleForm.reservationId){
                    this.orgids = element.organizationId;
                  }
                }
            }
        })
    },
    getList() {
      let _this = this;
      this.detailShow = true;
      tree({
        siteId: sessionStorage.getItem("siteId"),
        orgId:1,
      }).then((res) => {
        if (res.code == 0) {
          let options = JSON.stringify(res.data)
            .replace(/organizationName/g, "title")
            .replace(/id/g, "value");
          _this.treeData = JSON.parse(options);
          this.detailShow = false;
        }
      });
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #f4f4f6 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search {
    display: flex;
  }
  .back {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }
  .add-img {
    margin-right: 5px;
    margin-top: -3px;
    cursor: pointer;
  }
}
.log-box {
  //border-bottom: solid 1px #dcdfe6;
  display: flex;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 24px;
  .log {
    padding: 10px 20px;
    border-top: solid 1px #dcdfe6;
    border-left: solid 1px #dcdfe6;
    cursor: pointer;
    border-bottom: solid 1px #dcdfe6;
  }
  .log:last-child {
    border-right: solid 1px #dcdfe6;
    border-top-right-radius: 10px;
  }
  .log:first-child {
    border-top-left-radius: 10px;
  }
}
.dir {
  height: 1px;
  background: #dcdfe6;
  margin-left: 409px;
  margin-right: 24px;
  margin-top: -1px;
}
.status {
  border: solid 1px #dcdfe6;
  border-radius: 4px;
  padding-left: 10px;
}
/deep/ .el-radio__inner::after {
  width: 8px;
  height: 8px;
}
/deep/ .el-radio__inner {
  width: 16px;
  height: 16px;
}
/deep/ .ant-select-selection--single {
  height: 44px;
}
/deep/ .ant-select-selection__rendered {
  line-height: 38px;
  display: flex;
  align-items: center;
}
.choose_template {
  /deep/.el-dialog__title {
    font-size: 18px;
    font-weight: bold;
  }
  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
  /deep/ .el-dialog__close {
    font-weight: 600;
  }
  /deep/.el-dialog {
    width: 36%;
  }
  .lod-tips {
    background: #f7f7f7;
    font-size: 12px;
    color: #928f8f;
    line-height: 36px;
    padding: 0 10px;
    border-radius: 4px;
  }
  .choose-path {
    line-height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: solid 1px #dcdfe6;
    margin-top: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .template-list {
    border: solid 1px #dcdfe6;
    border-radius: 4px;
    margin-top: 20px;
    .list-box {
      height: 450px;
      overflow-y: auto;
    }
    .title {
      background: #f7f7f7;
    }
    .item {
      font-weight: bold;
      line-height: 52px;
      box-sizing: border-box;
      border-bottom: solid 1px #dcdfe6;
      padding: 0 10px;
      cursor: pointer;
      &:last-child {
        border: none;
      }
    }
  }
}
/deep/ .icon-arrow-back:before {
  font-size: 20px;
}
.lod-box {
  display: flex;
  align-items: center;
}
.back-box {
  margin-right: 10px;
  cursor: pointer;
}
.base_seting {
  overflow-y: auto;
  padding: 24px;
  max-width: 800px;
}
.delete-btn {
  position: absolute;
  margin-left: 10px;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 20px;
}
.column-box {
  .tree-box {
    max-height: 450px;
    overflow-y: auto;
    background: #f8f9fa;
  }
  /deep/.el-dialog__footer {
    padding-top: -5px;
  }
}
/deep/ .edui-default .edui-editor-toolbarbox {
  position: sticky;
  top: -10px;
  z-index: 9999;
}

/deep/ .edui-default .edui-editor-iframeholder,
.edui-default .edui-editor-iframeholder iframe {
  height:360px !important;
}
/deep/ .ant-drawer-title {
  font-weight: 600;
  font-size: 18px;
}
/deep/.ant-form-item-label {
  width: 121px;
}
/deep/ .ant-form-item {
  display: flex;
}
/deep/ .ant-form-item-control-wrapper {
  width: 100%;
}
.btn-box {
  margin-top: 24px;
  margin-left: 102px;
}
.el-button--primary {
  background: #176de6;
}
.change-model {
  width: calc(100% - 110px);
}
@media screen and (max-width: 720px) {
  .log-box {
    margin-left: 0px !important;
    margin-right: 0px !important;
    margin-top: 0px !important;
  }
  .form {
    width: 100% !important;
    margin-top: 20px;
  }
  .base_seting {
    padding: 0px !important;
    padding-right: 15px !important;
  }
  .demo-ruleForm {
    height: 50vh !important;
  }
  /deep/ .change-model {
    width: auto;
  }
  .choose_template .template-list .list-box {
    height: 45vh !important;
  }
  /deep/ .ant-form-item-label {
    width: 48%;
    text-align: center;
  }
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 16px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
/deep/ .el-form-item__label{
  text-align: left;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  background: #fff;
  z-index: 9999999999999;
  .form-bottom {
    margin-right: 24px;
    padding: 15px 0px;
  }
}
/deep/ .ant-drawer-body{
  padding: 0px !important;
}
/deep/.ant-drawer-content{
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
/deep/ .el-input-group__append, .el-input-group__prepend{
  border-radius: 0px 4px 4px 0px;
  background-color: rgba(24, 109, 230, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
}
.file-box{
  /deep/ .el-input__inner{
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-right: none !important;
  }
  
}
/deep/ .ant-select-selection--multiple .ant-select-selection__choice{
    float: left; 
    max-width:100%;
    margin-right: 4px; 
    padding: 0 20px 0 10px; 
    overflow: hidden; 
    color: rgba(0, 0, 0, 0.65); 
    background:none; 
    border: none; 
    border-radius:none; 
    cursor: default;
     transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.drop-box{
  width: 331px;
}
/deep/ .ant-select{
  max-width: 331px;
}
/deep/ .ant-select-selection--single{
  height:40px;
}
/deep/ .el-form-item__content{
  line-height: 0px;
}
</style>
